import { FC } from 'react';

import { Head, Link } from '@inertiajs/react';
import { SearchX } from 'lucide-react';

import { Button } from '../../components/ui/Button';

const NotFound: FC = () => (
    <>
        <Head title="Сторінку не знайдено | CartOn" />

        <section className="container flex min-h-[60vh] items-center justify-center px-4 py-16 text-center">
            <div className="flex max-w-xl flex-col items-center">
                <div className="mb-6 rounded-full bg-muted p-5">
                    <SearchX className="h-10 w-10 text-muted-foreground" />
                </div>

                <p className="mb-3 text-sm font-semibold tracking-widest text-primary uppercase">
                    Помилка 404
                </p>
                <h1 className="mb-4 text-3xl font-bold sm:text-4xl">
                    Сторінку не знайдено
                </h1>
                <p className="mb-8 text-muted-foreground">
                    Можливо, сторінку було переміщено, видалено або в адресі є
                    помилка.
                </p>

                <Button asChild size="lg">
                    <Link href="/">Повернутися на головну</Link>
                </Button>
            </div>
        </section>
    </>
);

export default NotFound;
